import { atom } from "jotai";

export const deepLinkAtom = atom<string | undefined>(undefined);
